// 空值用 -- 展示
// 后台数据空值时，前台需要用 -- 代替
// 已经注册到 vue 全局 filter {{ value | blankValue }}
const blankValue = value => value || '-';

export default { blankValue };
